import PurchaseSummaryPage from "components/PurchaseSummaryPage/PurchaseSummaryPage"

const PurchaseSummary = () => {
  return <PurchaseSummaryPage />
}

export default PurchaseSummary
